<template>
  <div class="d-flex flex-column fill-viewport">
    <EnvIndicator />
    <header class="guest-header">
      <span id="contractor-logo"></span>
      <div class="d-flex align-items-center gap-3">
        <GuestLanguageToggle />
        <span class="text-small">{{
          t('homeowner_experience.powered_by')
        }}</span>
      </div>
    </header>
    <div class="position-relative flex-fill d-flex slot-layout">
      <div class="container p-0">
        <slot />
      </div>
    </div>
    <footer class="guest-footer">
      <img
        :src="sealedHouse"
        alt="Sealed"
      />
      <div class="text-small">
        <span class="me-2">&copy;</span>
        <span>{{ t('homeowner_experience.footer', { year }) }}</span>
      </div>
    </footer>
  </div>
</template>
<script setup lang="ts">
import GuestLanguageToggle from '@/components/GuestLanguageToggle/GuestLanguageToggle.vue';
import sealedHouse from '@shared/assets/images/sealed_house_logo.svg';
import EnvIndicator from '@shared/components/EnvIndicator.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const year = new Date().getFullYear();
</script>
<style lang="scss" scoped>
.fill-viewport {
  background-color: var(--bs-white);
}

.guest-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.guest-footer {
  display: flex;
  justify-content: space-between;
  background-color: var(--bs-secondary);
  padding: 1rem 2rem;
}
</style>
